import React from 'react';

export const VerificationRequiredIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 1C8.243 1 6 3.243 6 6C6 8.757 8.243 11 11 11C13.757 11 16 8.757 16 6C16 3.243 13.757 1 11 1ZM11 9C9.346 9 8 7.654 8 6C8 4.346 9.346 3 11 3C12.654 3 14 4.346 14 6C14 7.654 12.654 9 11 9Z"
      fill="white"
    />
    <path
      d="M9 13H13.2L12 15H9C6.243 15 4 17.243 4 20V21H2V20C2 16.141 5.14 13 9 13Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5919 12.4276C15.6963 10.5241 18.304 10.5241 19.4083 12.4276L23.5763 19.6112C24.7358 21.6098 23.3803 24.1831 21.1681 24.1834H12.8322C10.62 24.1831 9.26451 21.6098 10.424 19.6112L14.5919 12.4276Z"
      fill="#FFCC00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 18V15H18V18H16ZM16 21V19H18V21H16Z"
      fill="#19283C"
    />
  </svg>
);
